export enum WageConditionalOperator {
  None = 0,
  LessThan = 1,
  GreaterThan = 2,
  Each = 3,
  Always = 4,
  EqualTo = 5
}

export const WageConditionalOperatorMapping: Record<WageConditionalOperator, string> = {
  [WageConditionalOperator.None]: '-- Select Operator --',
  [WageConditionalOperator.LessThan]: '<',
  [WageConditionalOperator.GreaterThan]: '>',
  [WageConditionalOperator.Each]: 'Each',
  [WageConditionalOperator.Always]: 'Always',
  [WageConditionalOperator.EqualTo]: '='
};
